import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { SuscriptionModalComponent } from './suscription-modal/suscription-modal.component';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ActivateLoadingAction, DeactivateLoadingAction } from 'src/app/redux/ui.actions';


@Component({
    selector: 'app-suscriptions',
    templateUrl: './suscriptions.component.html',
    styleUrls: ['./suscriptions.component.scss'],
    standalone: false
})
export class SuscriptionsComponent implements OnInit {

  subscriptions = [];
  planId = "";
  userPlan = { billing_cycle_end: "", cancelled_at: 0 };

  constructor(public service: AuthService, public dialog: MatDialog, private store: Store<AppState>) { }

  ngOnInit() {
    this.service.getPlans().subscribe((d: any) => {
      let decData = this.service.parseEncryptedResponse(d, "public");//private
      console.log(decData.data.items);
      this.subscriptions = [];
      decData.data.items.forEach(item => {
        if(!item.isBusiness)
          this.subscriptions.push(item);
      });
    }, err => {
      this.service.handleRequestError(err, {
        fallback: 'No pudimos cargar los planes disponibles. Intenta de nuevo en unos minutos.'
      });
    })
    this.getCurrentSuscription();
  }

  getCurrentSuscription() {
    this.service.getCurrentSuscription().subscribe((d: any) => {
      let decData = this.service.parseEncryptedResponse(d, "private");
      console.log(decData.data.items[0]);
      let data = decData.data.items[0];
      this.userPlan = data;
      this.planId = data.plan.conekta_id;
    }, err => {
      this.service.handleRequestError(err, {
        showModal: false,
        fallback: 'No se encontró suscripción activa.'
      });
      this.planId = "no_plan";
      if(this.service.user){
        if(this.service.user.account_status == "plan_unpaid"){
          this.height = '250px';
          this.addSubscription(this.service.user.plan_id);
        }
      }
    });
  }

  height = '200px';
  addSubscription(sub) {
    console.log(sub)

    const dialogRef = this.dialog.open(SuscriptionModalComponent, {
      width: '500px',
      height: this.height,
      data: { sub, title: `Al dar click en aceptar se realizara un cargo de $${sub.amount / 100} a su tarjeta.` }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        this.store.dispatch(new ActivateLoadingAction());
        this.service.addSuscription(sub.id, sub).subscribe((d: any) => {

          let decData = this.service.parseEncryptedResponse(d, "private");
          this.store.dispatch(new DeactivateLoadingAction());
          Swal.fire({
            icon: 'success',
            title: 'Ya cuentas con tu plan!!',
            text: "Tu suscripción al plan puede verse reflejada hasta dentro de 2 horas",
            showConfirmButton: true,
            confirmButtonText: "ok",
            confirmButtonColor:'#023171',
          });
          // console.log(decData)
          this.getCurrentSuscription();

        }, err => {
          this.store.dispatch(new DeactivateLoadingAction());
          this.service.handleRequestError(err, {
            fallback: 'No pudimos activar la suscripción. Intenta de nuevo en unos minutos.'
          });
        });
      }

    });
  }

  freeSuscription() {

    const dialogRef = this.dialog.open(SuscriptionModalComponent, {
      width: '500px',
      height: this.height,
      data: { title: `Estas seguro de cancelar el plan? si lo cancela aun tendra sus terapias pendientes` }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        this.service.deleteSuscription().subscribe((d: any) => {
          let decData = this.service.parseEncryptedResponse(d, "private");
          Swal.fire({
            icon: 'success',
            title: 'Bien',
            text: "Ya cancelo su suscripción con éxito",
            showConfirmButton: true,
            confirmButtonText: "ok",
            confirmButtonColor:'#023171',
          });
          console.log(decData);
          if(this.service.user.account_status == "plan_unpaid"){
            this.service.user.account_status = "activated";
            this.service.user.plan_id = null;
          }
          this.getCurrentSuscription();
        }, err => {
          this.service.handleRequestError(err, {
            fallback: 'No pudimos cancelar la suscripción. Intenta de nuevo en unos minutos.'
          });
        });
      }
    });


  }


}
